<template>
  <div>
    
    <div class="title">
       欢迎来到大树联合集团网站后台管理系统
     </div>
     <Backfooter></Backfooter>
  </div>
  
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
   
  
}
</script>
<style scoped>
@keyframes identifier {
 from{
   color: aqua;
   opacity: 0;
   /* transform: rotate3d(90deg) */
 }
 to{
   color: brown;
   opacity: 1;
    /* transform: rotate3d(0deg) */
 }
}
.title {
  font-size: 26px;
  color: red;
  text-align: center;
  /* height: 750px; */
  animation: identifier 2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/welcome.vue